const state = {
  paxel_big_customer: [],
  paxel_big_customer_id: [],
};

export default state;
